import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';

interface INewbuildingsLinkProps {
  onClick?(): void;
  url: string;
  label?: string;
}

export const NewbuildingsLink: React.FC<INewbuildingsLinkProps> = ({
  onClick,
  url,
  label = 'Смотреть ЖК по акции',
}) => {
  return (
    <LinkButton
      onClick={onClick}
      href={url}
      size="M"
      theme="fill_secondary"
      target="_blank"
      rel="noopener noreferrer"
      fullWidth
    >
      {label}
    </LinkButton>
  );
};
